import React from "react";
import { AccessTokenContext } from "../context/access-token-context";
export var useAccessToken = function () {
  return React.useContext(AccessTokenContext);
};